import { InitFeatureParams } from '@/features/types'
import { getRoutes } from './routes'

export const initQuestionnaireTask = ({ addRoutes }: InitFeatureParams) => {
  addRoutes(getRoutes())
}
